import { Controller } from '@hotwired/stimulus'
import L from 'leaflet'

const DEFAULT_LATITUDE = 39.8283
const DEFAULT_LONGITUDE = -98.5795
const DEFAULT_ZOOM = 4
const FOCUSED_ZOOM = 15

export default class extends Controller {
  static targets = ['latitudeInput', 'longitudeInput', 'map']

  static values = {
    latitude: Number,
    longitude: Number
  }

  connect () {
    this.loadMap()
  }

  disconnect () {
    if (this.map) this.map.remove()
  }

  loadMap () {
    const hasSavedCoordinates = this.hasLatitudeValue && this.hasLongitudeValue
    const center = hasSavedCoordinates
      ? [this.latitudeValue, this.longitudeValue]
      : [DEFAULT_LATITUDE, DEFAULT_LONGITUDE]
    const zoom = hasSavedCoordinates ? FOCUSED_ZOOM : DEFAULT_ZOOM

    this.map = L.map(this.mapTarget, {
      attributionControl: false,
      zoomControl: false
    }).setView(center, zoom)

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    }).addTo(this.map)

    this.marker = L.marker(center, {
      draggable: true,
      icon: this.markerIcon()
    }).addTo(this.map)

    this.marker.on('dragend', () => this.updateInputs(this.marker.getLatLng()))
    this.map.on('click', (event) => {
      this.marker.setLatLng(event.latlng)
      this.updateInputs(event.latlng)
    })

    this.updateInputs(this.marker.getLatLng())
    window.requestAnimationFrame(() => this.map.invalidateSize())

    if (!hasSavedCoordinates) this.locateUser()
  }

  locateUser () {
    if (!navigator.geolocation) return

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latlng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }

        this.marker.setLatLng(latlng)
        this.map.setView(latlng, FOCUSED_ZOOM)
        this.updateInputs(latlng)
      },
      () => {},
      { enableHighAccuracy: true, timeout: 8000 }
    )
  }

  markerIcon () {
    return L.divIcon({
      className: 'nature-map-pin',
      html: '<span class="nature-map-pin__marker"></span>',
      iconAnchor: [14, 28],
      iconSize: [28, 28]
    })
  }

  updateInputs (latlng) {
    this.latitudeInputTarget.value = latlng.lat.toFixed(6)
    this.longitudeInputTarget.value = latlng.lng.toFixed(6)
  }
}
